import { render, staticRenderFns } from "./system-announcement.vue?vue&type=template&id=0427652c&scoped=true"
import script from "./system-announcement.vue?vue&type=script&lang=js"
export * from "./system-announcement.vue?vue&type=script&lang=js"
import style0 from "./system-announcement.vue?vue&type=style&index=0&id=0427652c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0427652c",
  null
  
)

export default component.exports